import axios from 'axios';
import qs from 'qs';
import { version } from '@mobile/../package.json';
import { eventBus } from '@/eventBus';

const instance = axios.create();

const loggedInUser = JSON.parse(localStorage.getItem('user'));

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['Zyp-User-Agent'] = `MOBILE-${version}`;

// add user id as header for easier logging on server side
if (loggedInUser) {
    instance.defaults.headers.common['Zyp-User-ID'] = loggedInUser.id;
}

// instance.defaults.headers.common['Content-Type'] = 'application/json'

instance.interceptors.request.use((axiosConfig) => ({
    ...axiosConfig,
    paramsSerializer: (params) => qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false,
    }),
}));

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            eventBus.$emit('offline');
        } else {
            const { status } = error.response;

            // Show the user a 500 error
            if (status >= 500) {
                eventBus.$emit('server-error', error);
            }

            // Handle not found
            if (status === 404) {
                eventBus.$emit('not-found', error);
            }

            // Handle Forbidden
            if (status === 403) {
                eventBus.$emit('forbidden', error);
            }

            // Handle Unauthorized
            if (status === 401) {
                eventBus.$emit('unauthorized', error);
            }
        }

        return Promise.reject(error);
    },
);

export default instance;
